import { motion } from "framer-motion";
import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";

const WHATSAPP_URL =
  "https://wa.me/14158885550?text=" +
  encodeURIComponent("Hi Pebble Beach Luxury Ride, I'd like to request a quote.");
const BOOKING_URL = "tel:+18334575466";

export default function Footer() {
  return (
    <footer id="contact" data-testid="site-footer" className="scroll-mt-20 border-t border-line">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <img
          src="/images/logo-dark.png"
          alt="Pebble Beach Luxury Ride — a Global Luxury Ride brand"
          data-testid="footer-logo"
          className="mb-12 h-14 w-auto sm:h-16"
        />
        <motion.p
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl font-serif text-3xl font-light leading-snug tracking-tight text-bone sm:text-5xl"
        >
          The premier chauffeur fleet of{" "}
          <span className="italic text-champagne">Pebble Beach &amp; the Monterey Peninsula.</span>
        </motion.p>

        <div className="mt-12 flex flex-wrap gap-4">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-link"
            className="flex items-center gap-2 bg-champagne px-6 py-3 font-mono text-[11px] uppercase tracking-[0.25em] text-onyx transition-colors duration-300 hover:bg-champagne-light"
          >
            <MessageCircle className="h-3.5 w-3.5" />
            WhatsApp Concierge
          </a>
          <a
            href={BOOKING_URL}
            data-testid="footer-booking-link"
            className="flex items-center gap-2 border border-line px-6 py-3 font-mono text-[11px] uppercase tracking-[0.25em] text-bone transition-colors duration-300 hover:border-champagne/50 hover:text-champagne"
          >
            <Phone className="h-3.5 w-3.5" />
            Book / Request Quote
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-line pt-10 sm:grid-cols-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">Reservations</p>
            <a href="tel:+18334575466" className="mt-3 flex items-center gap-2 text-sm text-smoke transition-colors hover:text-bone">
              <Phone className="h-3.5 w-3.5 text-champagne/70" /> +1 (833) 457-5466
            </a>
            <a href="mailto:reservations@globalluxuryride.com" className="mt-2 flex items-center gap-2 text-sm text-smoke transition-colors hover:text-bone">
              <Mail className="h-3.5 w-3.5 text-champagne/70" /> reservations@globalluxuryride.com
            </a>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">Service Area</p>
            <p className="mt-3 flex items-start gap-2 text-sm text-smoke">
              <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0 text-champagne/70" />
              Pebble Beach · Monterey · Carmel-by-the-Sea · Big Sur · SJC · SFO · OAK · Napa Valley · Lake Tahoe
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">Hours</p>
            <p className="mt-3 text-sm text-smoke">24 hours, 7 days — by reservation.</p>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-line pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke/60">
            © {new Date().getFullYear()} Pebble Beach Luxury Ride · A Global Luxury Ride Brand · All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke/60">
            CPUC-Licensed TCP Carrier · $1.5M Commercially Insured
          </p>
        </div>
      </div>
    </footer>
  );
}
